const RequiredMessage = (props) => {
  return (
    <p style={{ paddingTop: '15px', paddingBottom: '15px' }}>
      * Indicates required field
    </p>
  )
}

export default RequiredMessage
